import { Placeholder } from "@aws-amplify/ui-react";
import { InputGroup } from "react-bootstrap";
import { FloatingLabel, Button, Form } from "react-bootstrap";
const TextInputClearable = ({
    controlId,
    label,
    value,
    onValueChanged,
    placeholder,
    maxLength = 0,
    minLength = 0,
    info = null,
    isLoading = false

}) => {
    const errorMessage = () => {
        var error = null;
        if (maxLength !== 0)
            error = (value?.length > maxLength) ? "Should be shorter" : ""
        if (minLength !== 0 && error === "")
            error = (value?.length < minLength) ? "Should be longer" : ""
        return error;

    }
    if (!isLoading)
        return (
            <InputGroup className="my-2" hasValidation>
                <FloatingLabel
                    controlId={controlId}
                    label={label}
                    className="flex-grow-1"
                >
                    <Form.Control
                        isInvalid={errorMessage() !== ""}
                        type="text"
                        value={value ?? ""}
                        style={{ height: '3.5rem' }}
                        className="rounded-end-0"
                        onChange={(e) => {
                            onValueChanged(
                                e.target.value
                            )
                        }}
                        placeholder={placeholder} />

                    <Form.Control.Feedback type="invalid">
                        {errorMessage()}

                    </Form.Control.Feedback>
                    <Form.Text>
                        {info}
                    </Form.Text>
                </FloatingLabel>

                <Button
                    variant="outline-secondary"
                    className="d-flex align-items-center rounded-start-0"
                    style={{
                        height: 'calc(3.5rem + 2px)',
                        borderColor: 'lightgrey',
                        borderLeft: 'none'
                    }}
                    onClick={() => {
                        onValueChanged("")
                    }}>
                    <span className="material-symbols-outlined">
                        close
                    </span>
                </Button>

            </InputGroup>
        )
    else return (
        <Placeholder className="my-2" style={{ height: '3.5rem' }}></Placeholder>
    )
}

export default TextInputClearable;



